export default __webpack_public_path__ + "static/brand-promo-video-d7a30474bc8711a3ea57737e9f8782b1.mp4";